import { Platform } from '@angular/cdk/platform';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BankGroup, TRANSACTIONGROUPS } from '@app/modules/vault/components/add-document/attribute-section/add-attribute-poup/demo-data';
import { AddCategoryComponent } from '../add-category/add-category.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'task-checklist-floater',
  templateUrl: './task-checklist-floater.component.html',
  styleUrls: ['./task-checklist-floater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskChecklistFloaterComponent implements OnInit {
  todayDate: Date;
  reviewed = false;
  isBrowserSafari;
  styleElement: HTMLStyleElement;

  @Input() hideDeleteButton = false;
  @Input() hideReviewButton = false;
  @Input() selectedTasksArray;
  @Input() fromBalanceRegister;
  @Input() fromTransactionRegister;
  @Input() checkReviewStatus;
  @Input() disableReviewButton;
  @Input() disableDeleteButton;
  @Input() disableCategoryButton;
  @Input() selectedCategories;
  @Input() canCreateIncomeExpense;
  @Input() transactionType;

  @Output() assigneeClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() dueDateClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() categoryClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() reviewClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearClicked: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('expenseIncomeCategory') expenseIncomeCategory: AddCategoryComponent;

  taskForm: UntypedFormGroup;

  status = [
    { key: '1', value: 'complete', displayText: 'Complete', color: '#27AE60', backgroundColor: 'rgba(39, 174, 96, 0.1)' },
    { key: '2', value: 'in progress', displayText: 'In Progress', color: '#2F80ED', backgroundColor: 'rgba(47, 128, 237, 0.1)' },
    { key: '3', value: 'scheduled', displayText: 'Scheduled', color: '#9B51E0', backgroundColor: 'rgba(155, 81, 224, 0.1)' },
  ];

  category = [
    { value: 'category1', displayText: 'category1' },
    { value: 'category2', displayText: 'category2' },
    { value: 'category3', displayText: 'category3' },
  ];

  protected areas: BankGroup[] = TRANSACTIONGROUPS;
  selectedAreas: BankGroup[] = this.areas;
  isOpen = false;
  area = new UntypedFormControl('', [Validators.required]);
  myForm = this._fb.group({
    area: this.area,
  });

  constructor(private _fb: UntypedFormBuilder, private platform: Platform) {
    const now = new Date();
    this.todayDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  }

  ngOnInit(): void {
    this.isBrowserSafari = this.platform.SAFARI;
    this.taskForm = this._fb.group({
      dueDate: [''],
    });
  }

  changeAssignee() {
    this.assigneeClicked.emit('changeAssignee');
  }

  changeStatus(status) {
    const payload = {
      type: 'changeStatus',
      status: status,
    };
    this.statusClicked.emit(payload);
  }

  changeDueDate() {
    if (this.taskForm.controls['dueDate'].value) {
      const payload = {
        type: 'changeDueDate',
        date: this.taskForm.controls['dueDate'].value,
      };

      this.dueDateClicked.emit(payload);
    }
  }

  changeReviewStatus() {
    const payload = {
      type: 'changeReviewStatus',
      reviewStatus: this.checkReviewStatus,
    };
    this.reviewClicked.emit(payload);
  }

  deleteTasks() {
    this.deleteClicked.emit('deleteTasks');
  }

  clearSelection() {
    this.clearClicked.emit('closeSelection');
  }

  onCategorySelection(event) {
    this.categoryClicked.emit(event);
  }

  onSelectOpened(isOpen) {
    if (!isOpen) this.expenseIncomeCategory.closeCategoryDropdown();
  }

  search(query: string) {
    let result = this.select(query);
    this.selectedAreas = result;
  }

  select(query: string): BankGroup[] {
    let result: BankGroup[] = [];
    for (let a of this.areas) {
      if (a.name.toLocaleLowerCase().includes(query.toLocaleLowerCase())) {
        result.push(a);
      } else {
        let filterData = a.banks.filter((x) => x.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
        if (filterData.length) {
          let pushData = a;
          pushData.banks = a.banks.filter((x) => x.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
          result.push(pushData);
        }
      }
    }
    return result;
  }

  focusOutFunction() {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      eval(`document.getElementById('input-category-search').value='';`);
      this.search('');
    }
  }

  ShowChildOptionEstate(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
  }

  SelectChildOptionEstate($event, currentData) {
    this.selectedAreas.forEach((element) => {
      element.isOpen = false;
    });
  }

  openCategoryDropdown(ev: Event) {
    ev.stopPropagation();
    ev.preventDefault();
    this.expenseIncomeCategory.openCategoryDropdown();
  }
}
